<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Users Data table
            </h2>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto h-full sm:px-6 lg:px-8">
                <div class="bg-white border-b border-gray-200">
                    <data-table :users="users" class="block h-auto w-auto" />
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "./../Layouts/AppLayout";
import DataTable from "./../Jetstream/Table";

export default {
    components: {
        AppLayout,
        DataTable
    },
    props: {
        users: Array
    }
};
</script>
